import PropTypes from 'prop-types';
import React from 'react';
import ZoomTestCallRetryer from './ZoomTestCallRetryer';

import ZoomTestCallContainer from './ZoomTestCallContainer';

const ZoomTestCallCheck = ({ credentials, isFailed }) => {
    return isFailed
        ? <ZoomTestCallRetryer />
        : <ZoomTestCallContainer credentials={credentials} />;
};

ZoomTestCallCheck.propTypes = {
    credentials: PropTypes.object,
    isFailed: PropTypes.bool.isRequired,
};

export default ZoomTestCallCheck;
